import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["formContent", "fullButton", "trialButton"]
  static values = { url: String, courseId: Number }

  async selectType(event) {
    const button = event.currentTarget
    const subscriptionType = button.dataset.type

    this.fullButtonTarget.classList.toggle('active', subscriptionType === 'full')
    this.trialButtonTarget.classList.toggle('active', subscriptionType === 'trial')

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set('course_id', this.courseIdValue)
    url.searchParams.set('subscription_type', subscriptionType)

    try {
      const response = await fetch(url, {
        headers: {
          'Accept': 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      })

      if (response.ok) {
        this.formContentTarget.innerHTML = await response.text()
      }
    } catch (error) {
      console.error('Error fetching form:', error)
    }
  }
}
